/* Vestigium · zona de compra (SPEC4). CSS: vestigium.css §15. Botón: snippets/buy-buttons.liquid.
   Va antes de vestigium-interaccion.js, que revela los beneficios que aquí se marcan. No escribe en el
   primer <span> del botón ni en el bloque de precio: son del tema (global.js, product-form.js). */
(function () {
	'use strict';
	if (window.vgCompra) return;
	window.vgCompra = 1;
	var d = document, vio, ultimo;
	function on(el, t, f, o) { el.addEventListener(t, f, o); }
	function quieto() { return matchMedia('(prefers-reduced-motion: reduce)').matches; }
	function cada(s, q, f) { Array.prototype.forEach.call(s.querySelectorAll(q), f); }
	function marca(el, k) { k = '_vgc' + k; if (el[k]) return 1; el[k] = 1; }
	function clase(el, c, ms) { // la pone un rato; si ya estaba, su animación empieza de nuevo
		el.classList.remove(c);
		void el.offsetWidth;
		el.classList.add(c);
		clearTimeout(el['_t' + c]);
		el['_t' + c] = setTimeout(function () { el.classList.remove(c); }, ms);
	}

	// Precio tomado del propio texto («49,99 €» o «€49.99»): el decimal es el último [.,] seguido de 2 cifras
	function cifra(t) {
		var m = /\d[\d.,]*/.exec(t), s = m && m[0].replace(/[.,]$/, ''), k, p;
		if (!s) return null;
		k = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
		p = k > -1 && s.length - k == 3 ? s[k] : '';
		return { v: +((p ? s.slice(0, k) : s).replace(/[.,]/g, '') + (p ? '.' + s.slice(k + 1) : '')), m: s, p: p };
	}
	// §2 Precio que cuenta: cuenta una copia aria-hidden; el real (role=status) espera oculto a la vista
	function cuenta(el, de) {
		var tx = el.textContent.trim(), f = cifra(tx), s, t0;
		if (!f || !(de >= 0) || de === f.v || quieto()) return;
		s = el.cloneNode();
		s.setAttribute('aria-hidden', 'true');
		s.classList.add('vg-cuenta');
		el.classList.add('visually-hidden');
		el.after(s);
		requestAnimationFrame(function paso(t) {
			var k = t0 ? Math.min(1, (t - t0) / 420) : 0, x = de + (f.v - de) * (1 - Math.pow(1 - k, 3));
			t0 = t0 || t;
			if (k < 1 && s.isConnected) {
				s.textContent = tx.replace(f.m, f.p ? x.toFixed(2).replace('.', f.p) : Math.round(x));
				requestAnimationFrame(paso);
			} else {
				s.remove();
				el.classList.remove('visually-hidden');
			}
		});
	}
	// global.js repinta el bloque de precio y justo después el texto del botón. Aquí, al acabar: el precio
	// pasa al botón (solo se ve con «Añadir al carrito», no con «Agotado» o «No disponible») y cuenta.
	function precios(s) {
		cada(s, '.product__info-container [id^="price-"]', function (c) {
			if (marca(c, 'p')) return;
			var b = d.getElementById('ProductSubmitButton-' + c.id.slice(6)), q = b && b.querySelector('[data-vg-precio]'),
				a = (window.variantStrings || {}).addToCart, el;
			function lee() {
				var p = c.querySelector('.price'), t, f,
					n = p && c.querySelector(p.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
				if (q && a) b.classList.toggle('is-vg-sin-precio', b.querySelector('span').textContent.trim() !== a.trim());
				if (!n || n === el) return;
				if (el) cuenta(n, c._vgV);
				el = n;
				t = n.textContent.trim();
				f = cifra(t);
				c._vgV = f && f.v;
				if (q && t) q.textContent = t;
			}
			lee();
			new MutationObserver(lee).observe(c, { childList: true, attributes: true, attributeFilter: ['class'] });
		});
	}

	// En pantalla: brillos (botón y oferta), latido del botón la primera vez y estrellas que esperan a verse
	if (window.IntersectionObserver) vio = new IntersectionObserver(function (es) {
		es.forEach(function (e) {
			var el = e.target, c = el.classList, si = e.isIntersecting;
			c.toggle('is-vg-en-pantalla', si);
			if (si) el._vgYa = 1;
			c.toggle('is-vg-espera', !el._vgYa);
			if (e.intersectionRatio >= 0.6 && !el._vgLat && !el.disabled && c.contains('vg-compra')) {
				el._vgLat = 1;
				clase(el, 'is-vg-latido', 1400);
			}
		});
	}, { threshold: [0, 0.6] });

	// §1 Al pulsar: 7 huellitas y corazones desde el dedo, con un giro al azar (trayectorias en el CSS)
	var PATA = '<ellipse cx="12" cy="16.5" rx="5.5" ry="4.5"/><circle cx="5" cy="10" r="2.2"/><circle cx="9.5" cy="5.5" r="2.4"/><circle cx="14.5" cy="5.5" r="2.4"/><circle cx="19" cy="10" r="2.2"/>',
		CORAZON = '<path d="M12 21C6 17 3 13 3 9.5a4.5 4.5 0 0 1 9-1.5 4.5 4.5 0 0 1 9 1.5C21 13 18 17 12 21Z"/>';
	on(d, 'click', function (e) {
		var b = e.target.closest && e.target.closest('.vg-compra'), r, h = '', i, c;
		if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true' || quieto()) return;
		r = b.getBoundingClientRect();
		for (i = 0; i < 7; i++) h += '<svg class="vg-chispa" viewBox="0 0 24 24">' + (i % 3 ? CORAZON : PATA) + '</svg>';
		c = d.createElement('i');
		c.className = 'vg-chispas';
		c.setAttribute('aria-hidden', 'true');
		c.style.cssText = 'left:' + Math.round(e.detail ? e.clientX - r.left : r.width / 2) + 'px;top:' +
			Math.round(e.detail ? e.clientY - r.top : r.height / 2) + 'px;rotate:' + Math.round(Math.random() * 30 - 15) + 'deg';
		c.innerHTML = h;
		// Antes del spinner: base.css oculta lo que va detrás de él (.loading__spinner:not(.hidden) ~ *)
		b.insertBefore(c, b.querySelector(':scope > .loading__spinner'));
		setTimeout(function () { c.remove(); }, 950);
	});

	// §1 Tras añadir (product-form.js publica cartUpdate solo si fue bien; si no, enseña su error):
	// «¡Añadido!» 1,5 s, aviso aria-live y el carrito de la cabecera salta con su número nuevo (solo aquí: _SPEC3 §2)
	on(d, 'submit', function (e) { ultimo = e.target.querySelector && e.target.querySelector('.vg-compra'); }, true);
	var hay = typeof subscribe == 'function' && typeof PUB_SUB_EVENTS != 'undefined';
	// Aviso: el cajón es aria-modal y lo de fuera no se lee; si está abierto, va en su región viva
	function avisa(a) {
		var t = a.getAttribute('data-vg-anuncio'), r = d.querySelector('cart-drawer.active') && d.getElementById('CartDrawer-LiveRegionText') || a;
		a.textContent = r.textContent = '';
		r.removeAttribute('aria-hidden');
		setTimeout(function () { r.textContent = t; }, 50);
		clearTimeout(a._vgT);
		a._vgT = setTimeout(function () { if (r.textContent == t) r.textContent = ''; }, 5000);
	}
	// El cajón tapa el icono: si está abierto, el salto espera a que se cierre
	function salta(z) {
		var cd = d.querySelector('cart-drawer.active');
		if (z._vgMo) z._vgMo.disconnect();
		if (!cd) return clase(z, 'is-vg-salto', 900);
		(z._vgMo = new MutationObserver(function () {
			if (cd.classList.contains('active')) return;
			z._vgMo.disconnect();
			setTimeout(function () { clase(z, 'is-vg-salto', 900); }, 350);
		})).observe(cd, { attributes: true, attributeFilter: ['class'] });
	}
	if (hay) subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
		try { // corre antes de que product-form.js abra el cajón: un fallo aquí no debe cortar la compra
			var b = ultimo, a = b && b.parentNode && b.parentNode.querySelector('[data-vg-anuncio]'), z = d.getElementById('cart-icon-bubble'),
				s = z && z.closest('.shopify-section'), id = s && s.id.slice(16), cc = d.querySelector('cart-notification, cart-drawer'), ya;
			if (!ev || ev.source !== 'product-form') return;
			ultimo = null;
			if (b) clase(b, 'is-vg-anadido', 1500);
			if (a) setTimeout(function () { avisa(a); }, 150); // con el cajón ya pintado y abierto
			if (!z) return;
			// cart-drawer.js de Zendrop no repinta el número: se pide la cabecera, salvo si el carrito ya lo hace
			try { ya = cc.getSectionsToRender().some(function (x) { return x.id == 'cart-icon-bubble'; }); } catch (err) { /* sin carrito */ }
			(id && !ya ? fetch(location.pathname + '?sections=' + id).then(function (r) { return r.json(); }).then(function (j) {
				var n = new DOMParser().parseFromString(j[id], 'text/html').getElementById('cart-icon-bubble');
				if (n) z.innerHTML = n.innerHTML;
			}) : Promise.resolve()).catch(function () {}).then(function () { setTimeout(function () { salta(z); }, 30); });
		} catch (err) { /* nada */ }
	});
	// Al cambiar de pack, el botón toma precio y estado del HTML que trae global.js (aunque falte el bloque de precio)
	if (hay) subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
		try {
			var x = e.data, n = x.html.getElementById('ProductSubmitButton-' + x.sectionId), b = n && d.getElementById(n.id),
				p = n && n.querySelector('[data-vg-precio]'), q = b && b.querySelector('[data-vg-precio]'), v = b && b.form && b.form.querySelector('[name=id]');
			if (!p || !q || !v || v.value != x.variant.id) return;
			q.textContent = p.textContent;
			b.classList.toggle('is-vg-sin-precio', n.classList.contains('is-vg-sin-precio'));
		} catch (err) { /* nada */ }
	});

	// §2 Tarjetas de pack: la elegida da un saltito y su ahorro hace «pop» (un solo listener, delegado)
	on(d, 'change', function (e) {
		var t = e.target, l = t.nextElementSibling;
		if (t.type == 'radio' && l && t.closest('.vg-packs') && !t.classList.contains('disabled') && !quieto()) clase(l, 'is-vg-salta', 450);
	});
	on(d, 'touchstart', function () {}, { passive: true }); // iOS: así aplica :active al tocar una tarjeta

	// §2 Galería del móvil: pista «desliza» a los 2 s, una vez por sesión, si hay más fotos y no se ha deslizado
	function guarda() { try { sessionStorage.vgDesliza = 1; } catch (e) { /* sin almacenamiento */ } }
	function desliza(s) {
		try { if (sessionStorage.vgDesliza) return; } catch (e) { /* sin almacenamiento */ }
		if (!matchMedia('(max-width: 749px)').matches || (window.Shopify && Shopify.designMode)) return;
		cada(s, 'media-gallery .product__media-list', function (ul) {
			var h = ul.parentNode, x, p;
			if (marca(ul, 'd')) return;
			on(ul, 'scroll', function () { if (x) return; x = 1; guarda(); if (p) p.remove(); }, { passive: true });
			setTimeout(function () {
				var r = ul.getBoundingClientRect();
				if (x || ul.scrollWidth <= ul.clientWidth + 1 || r.bottom < 80 || d.querySelector('.vg-desliza')) return;
				if (getComputedStyle(h).position == 'static') h.style.position = 'relative';
				p = d.createElement('span');
				p.className = 'vg-desliza';
				p.setAttribute('aria-hidden', 'true');
				p.innerHTML = '<svg viewBox="0 0 28 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M26 9C18 7 11 8 4 8m5-5-5 5 5 4"/></svg>desliza';
				p.style.top = ul.offsetTop + ul.offsetHeight / 2 + 'px';
				h.appendChild(p);
				guarda();
				setTimeout(function () { p.remove(); }, 3300);
			}, 2000);
		});
	}

	function iniciar(s) {
		s = s && s.querySelectorAll ? s : d;
		[function () { // §2 Beneficios: los revela, escalonados, vestigium-interaccion.js
			cada(s, '.product__info-container > .product__text', function (el) { el.setAttribute('data-vg-reveal', ''); });
		}, precios, desliza, function () {
			if (vio) cada(s, '.vg-compra, .product__info-container .urgency-text, .product__info-container .vg-valoracion', function (el) {
				if (!marca(el, 'v')) vio.observe(el);
			});
		}].forEach(function (f) {
			try { f(s); } catch (err) { /* si una pieza falla, las demás siguen */ }
		});
	}
	if (d.readyState === 'loading') on(d, 'DOMContentLoaded', function () { iniciar(); });
	else iniciar();
	on(d, 'shopify:section:load', function (e) { iniciar(e.target); });
})();

/* Flechas a ambos lados de la galería en el móvil (19/10/2026, petición de los socios).
   Se añaden dentro de slider-component#GalleryViewer-… (ficha y portada) y mueven la tira
   ul.product__media-list una foto. El tema sigue enterándose del cambio por su evento de
   scroll (miniaturas y contador). En la primera foto se oculta la de la izquierda y en la
   última la de la derecha. En escritorio el CSS las esconde. */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
  var svg = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15.2 4.6c-2.4 2.5-4.7 4.9-7 7.3 2.3 2.5 4.6 4.9 7 7.4"/></svg>';

  function visibles(lista) {
    return Array.prototype.filter.call(lista.children, function (li) {
      return li.classList.contains('product__media-item') && li.offsetWidth > 0;
    });
  }

  function montar(raiz) {
    (raiz || document).querySelectorAll('media-gallery slider-component[id^="GalleryViewer-"]').forEach(function (sc) {
      if (sc.querySelector(':scope > .vg-flecha-galeria')) return;
      var lista = sc.querySelector('.product__media-list');
      if (!lista || lista.children.length < 2) return;
      var botones = {};
      ['prev', 'next'].forEach(function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vg-flecha-galeria vg-flecha-galeria--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Foto anterior' : 'Foto siguiente');
        if (lista.id) b.setAttribute('aria-controls', lista.id);
        b.innerHTML = svg;
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var v = visibles(lista);
          if (v.length < 2) return;
          var paso = v[1].offsetLeft - v[0].offsetLeft || v[0].offsetWidth;
          lista.scrollBy({ left: dir === 'prev' ? -paso : paso, behavior: reducido.matches ? 'auto' : 'smooth' });
        });
        sc.appendChild(b);
        botones[dir] = b;
      });
      var pendiente = false;
      function actualizar() {
        pendiente = false;
        var max = lista.scrollWidth - lista.clientWidth - 4;
        var hay = visibles(lista).length > 1 && max > 0;
        botones.prev.hidden = !hay || lista.scrollLeft <= 4;
        botones.next.hidden = !hay || lista.scrollLeft >= max;
      }
      lista.addEventListener('scroll', function () {
        if (!pendiente) { pendiente = true; requestAnimationFrame(actualizar); }
      }, { passive: true });
      window.addEventListener('resize', actualizar, { passive: true });
      actualizar();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { montar(); });
  else montar();
  document.addEventListener('shopify:section:load', function (e) { montar(e.target); });
})();